// @flow
import $ from 'jquery';
import maskInput from '../../../utils/maskInput';
import JQueryView, { on, removeInvalidFeedback } from '../../common/JQueryView';
import DateRangePicker from '../../common/DateRangePicker';
import { purpose } from '../../../models/companies/Company';
import dayjs from 'dayjs';
import { informationSource } from '../../../models/User';

export default class ShowView extends JQueryView {
  constructor() {
    super('.simple_form');

    $('.form-group-float').each((index, element) => {
      const control = $(element).find('.form-control');
      if (control.val().length !== 0) {
        control.addClass('form-control-active');
      } else {
        control.removeClass('form-control-active');
      }
    });

    this.render();
    this.renderAdditionalForm();
  }

  @on({ event: 'change', selector: '#company_purpose_id' })
  onChangePurposeId() {
    this.renderAdditionalForm();
  }

  @on({ event: 'change', selector: '#user_information_source_id' })
  onChangeInformationSourceId() {
    this.renderAdditionalForm();
  }

  @on({ event: 'change', selector: '#company_growth_stage' })
  onChangeGrowthStage() {
    this.renderAdditionalForm();
  }

  initDateRangePicker(container: any) {
    new DateRangePicker(
      container,
      {
        singleDatePicker: true,
        datePicker: true,
        timePicker: false,
        timePicker24Hour: false,
        showDropdowns: true,
        maxDate: dayjs(),
        locale: {
          format: 'YYYY/MM/DD',
        },
      },
      {
        picker: {
          format: {
            start: 'YYYY/MM/DD',
            template: startDate => startDate,
          },
        },
      },
    ).render();
  }

  @on({ event: 'change', selector: '.form-control' })
  onChangeFormControl(event: any) {
    const target = $(event.target);
    if (target.val().length !== 0) {
      target.find('.form-control').addClass('form-control-active');
      target.removeClass('is-invalid');
      removeInvalidFeedback(target);
      target.removeClass('focus');
    }
  }

  @on({ event: 'blur input', selector: '.form-group-float, .form-control' })
  onBlurFormControl(event: any) {
    const target = $(event.target);
    if (target.hasClass('date-field') && $('.show-calendar').is(':visible')) {
      target.addClass('form-control-active');
      target.addClass('focus');
    } else {
      if (target.val().length === 0) {
        target.removeClass('form-control-active');
      } else {
        target.addClass('form-control-active');
        target.removeClass('is-invalid');
        removeInvalidFeedback(target);
      }
    }
  }

  @on({ event: 'click' })
  onClickOtherArea(event: any) {
    if (!$(event.target).closest('.date-field').length) {
      $('.date-field').removeClass('focus');

      if ($('.date-field').val().length === 0) {
        $('.date-field').removeClass('form-control-active');
      }
    }
  }

  render() {
    this.initDateRangePicker(this.$el);
  }

  renderAdditionalForm() {
    const purposeId = $('#company_purpose_id').val();
    const InformationSourceId = $('#user_information_source_id').val();
    const growthStage = $('#company_growth_stage').val();
    $('.display-purpose-note').css(
      'display',
      parseInt(purposeId) === purpose.other ? 'block' : 'none',
    );
    $('.company_stockholder_meeting_plan_id').css(
      'display',
      parseInt(purposeId) === purpose.stockholderMeeting ? 'block' : 'none',
    );
    $('.display-information-source-note').css(
      'display',
      parseInt(InformationSourceId) === informationSource.other
        ? 'block'
        : 'none',
    );
    $('.display-growth-stage-note').css(
      'display',
      growthStage === 'other' ? 'block' : 'none',
    );
    maskInput();
  }
}
